import { useEffect, useState } from 'react';

export type checkoutAddress = {
  firstName: string;
  lastName: string;
  company: string;
  address: string;
  city: string;
  state: string;
  zipCode: string;
  email: string;
  phone: string;
  address2: string;
};
export type shippingMethod = {
  shippingMethod: string;
  fedExNumber: string;
  deliverySelection: string;
};
export type CheckoutData = {
  addressData: checkoutAddress;
  shippingMethod: shippingMethod;
};
export type CheckoutProps = {
  checkOutData: CheckoutData;
};
const defaultCheckoutData: CheckoutProps = {
  checkOutData: {
    addressData: {
      firstName: '',
      lastName: '',
      company: '',
      address: '',
      city: '',
      state: '',
      zipCode: '',
      email: '',
      phone: '',
      address2: '',
    },
    shippingMethod: {
      shippingMethod: '',
      fedExNumber: '',
      deliverySelection: '',
    },
  },
};
const CHECKOUT_KEY = 'nrc-checkout';
export function getOrderData(): CheckoutProps {
  const orderData = localStorage.getItem(CHECKOUT_KEY);
  const storedCheckoutData: CheckoutProps = orderData ? JSON.parse(orderData) : defaultCheckoutData;
  return storedCheckoutData;
}
export function setOrderData(data: CheckoutProps): void {
  localStorage.setItem(CHECKOUT_KEY, JSON.stringify(data));
}

export function setOrderAddress(data: checkoutAddress): void {
  const orderData = getOrderData();
  if (orderData?.checkOutData?.addressData !== undefined) {
    orderData.checkOutData.addressData = data;
  }
  localStorage.setItem(CHECKOUT_KEY, JSON.stringify(orderData));
}
export function setShippingMethod(data: shippingMethod): void {
  const orderData = getOrderData();
  if (orderData?.checkOutData?.shippingMethod !== undefined) {
    orderData.checkOutData.shippingMethod = data;
  }
  localStorage.setItem(CHECKOUT_KEY, JSON.stringify(orderData));
}
export function clearOrderData(): void {
  localStorage.removeItem(CHECKOUT_KEY);
}
export const useCheckout = (): {
  checkoutData: CheckoutProps;
} => {
  const [checkoutData, setCheckout] = useState<CheckoutProps>(defaultCheckoutData);
  useEffect(() => {
    if (typeof window !== 'undefined' && window.localStorage) {
      setCheckout(getOrderData());
    }
  }, []);
  return {
    checkoutData,
  };
};
